import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
const API_URL = import.meta.env.VITE_API_URL;

const ReportContent = ({data, tableColumns}) => {
    const columns = [
        {id: "time", label: "Registro", renderCell: element => element.time ?? ""},
        {id: "inicio", label: "Início", className: "w-[125px]", renderCell: element => element.inicio ?? ""},
        {id: "fim", label: "Fim", className: "w-[125px]", renderCell: element => element.fim ?? ""},
        {
            id: "guarnicao",
            label: "Guarnição",
            renderCell: element => <a className="text-blue-600 print:!text-black" href={API_URL + `/despacho/garrison/form/${element.guarnicao_id}`} target="_blank">{element.guarnicao ?? ""}</a>
        },
        {id: "contingentes", label: "Contingentes", renderCell: element => element.contingentes ?? ""},
        {id: "equipe", label: "Equipe", renderCell: element => element.equipe ?? ""},
        {id: "setores", label: "Setor", renderCell: element => element.setores ?? ""},
        {id: "acao", label: "Ações", renderCell: element => element.acao ?? ""}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Ações por guarnição`, "garrison-actions");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="garrison-actions" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`} sheet-name="Ações por guarnição">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {data.map((element, index) => (
                        <tr key={index} className="table-break-word">
                            {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div id="chart-tables"/>

        </>
    );
};

export default ReportContent;